import type { Idioma } from '../../i18n/index.js';

/**
 * Cuántos estudios hay, dicho como lo diría una persona: «más de 140», no «144».
 *
 * El número exacto envejece con cada estudio nuevo y no le dice nada a quien lee; la decena sí.
 * Por debajo de 20, o si es una decena exacta, se da tal cual.
 */
export function estudiosEnRedondo(n: number, idioma: Idioma): string {
  const decena = Math.floor(n / 10) * 10;
  if (n < 20 || decena === n) return idioma === 'es' ? `${String(n)} estudios` : `${String(n)} studies`;
  return idioma === 'es' ? `Más de ${String(decena)} estudios` : `More than ${String(decena)} studies`;
}
